import { BaseModel } from '../base.model';

class PassageRequest {}

namespace PassageRequest {


  export class Create extends BaseModel {
    title: string = undefined;
    content: string = undefined;

  }

  export class Update extends BaseModel {
    title: string = undefined;
    content: string = undefined;
  }


}

export { PassageRequest };

